import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { ascSort } from '@common/helpers/declarative/sortings';
import { useDataFetch } from '@common/hooks/dataFetch';

import MultiplesItem from './pieces/multiplesItem';

import './style.scss';

const PredefinedMultiples = (props) => {
  const [data, setData] = useState(null);
  const [response] = useDataFetch(() => swarmRequest({}, 'get_predefined_multiples'), []);
  const vertical = window.innerWidth < window.innerHeight;

  useEffect(() => {
    const timeoutIds = [];

    if (response) {
      const { details } = response;

      const columns = details
        .filter((multiple) => moment(new Date()).isBefore(moment(multiple.ExpiresAt)))
        .sort(ascSort('Order'));

      columns.forEach((multiple) => {
        const now = moment.now();
        const expiresAt = moment(multiple.ExpiresAt);
        const durationInMiliseconds = moment.duration(expiresAt.diff(now)).asMilliseconds();

        timeoutIds.push(setTimeout(() => {
          setData((newData) => newData.filter((item) => item.Id !== multiple.Id));
        }, durationInMiliseconds));
      });

      setData(columns);
    }

    return () => timeoutIds.forEach(clearTimeout);
  }, [response]);

  return (
    <div className={`predefined-multiples-sport-contain ${vertical ? 'vertical' : ''}`}>
      {data?.filter((item) => item.Selections?.length).map((multiple) => (
        <MultiplesItem
          key={multiple.Id}
          multiple={multiple}
          bonusPercent={multiple.BonusPercent}
          {...props}
        />
      ))}
    </div>
  );
};

PredefinedMultiples.propTypes = {
  balance: PropTypes.number,
  config: PropTypes.object.isRequired,
  partnerConfig: PropTypes.object.isRequired,
  currencyConfig: PropTypes.object.isRequired,
};

export default PredefinedMultiples;
